export default {
    url: 'refurbished',
    include: ['us'],
};
